import http from "./Http";

const createTicket = async (body) => {
    const { data } = await http.post("/support-tickets", body);
    return data;
};

const SupportTicketService = {
    createTicket,
};

export default SupportTicketService;
